<div *ngIf="reportType === 'Monthwise'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ================= HEADER ================= -->
    <table style="width:100%;border-collapse:collapse;border:1px solid black;">
      <tr>
        <th colspan="5" style="border:1px solid black;font-size:18px;font-weight:bold;text-align:center">
          हिंदुस्तान प्रकाशन संस्था
        </th>
        <th colspan="8" style="border:1px solid black;font-size:18px;font-weight:bold;text-align:center">
          Book Registration Ledger Report
        </th>
        <th colspan="4" style="border:1px solid black;font-size:18px;font-weight:bold;text-align:end;">
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <tr>
        <th colspan="5" style="border:1px solid black;font-size:16px;font-weight:bold;text-align:center">
          विवेक पुस्तक प्रकाशन
        </th>
        <th colspan="8" style="border:1px solid black;font-size:16px;font-weight:bold;text-align:center">
         Office Represantive Briefly
        </th>
        <th colspan="4" style="border:1px solid black;font-size:16px;font-weight:bold;text-align:end;">
          {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
    </table>

    <!-- ================= DATA TABLE ================= -->
    <table style="width:100%;border-collapse:collapse;border:1px solid black;font-size:13px;">

      <thead>
        <tr>
          <!-- <th style="border:1px solid black;">Sr</th> -->
          <!-- <th style="border:1px solid black;">Order Date</th> -->
          <!-- <th style="border:1px solid black;">Order No</th> -->
          <th style="border:1px solid black;">Book Seller Name</th>
          <th style="border:1px solid black;">District</th>
          <th style="border:1px solid black;">Mobile No</th>
          <th style="border:1px solid black;">Book Name</th>
          <th style="border:1px solid black;">Sale copies</th>
          <th style="border:1px solid black;">Return copies</th>
          <th style="border:1px solid black;">Comp copies</th>
          <!-- <th style="border:1px solid black;">Book Price</th> -->
          <!-- <th style="border:1px solid black;">Sale Price</th> -->
          <th style="border:1px solid black;">Net Price</th>
          <th style="border:1px solid black;">Shipping</th>
          <th style="border:1px solid black;">Total</th>
          <th style="border:1px solid black;">Paid Amt</th>
          <th style="border:1px solid black;">Credit Amt</th>
          <th style="border:1px solid black;">Unpaid Amt</th>
          <!-- <th style="border:1px solid black;">Invoice</th> -->
          <th style="border:1px solid black;"> Rep<br>Commission<br>Amt</th>
        </tr>
      </thead>

      <tbody>

        <ng-container *ngFor="let office of groupedOfficeRepData">

          <!-- OFFICE HEADER -->
          <tr>
            <td colspan="20" style="border:1px solid black;font-weight:bold;text-align:center;font-size:16px;">
              Office Representative : {{ office.office_rep_name }}
            </td>
          </tr>

          <ng-container *ngFor="let rep of office.reps">

            <!-- REP HEADER -->
            <tr>
              <td colspan="20" style="border:1px solid black;font-weight:bold;">
                Rep Name : {{ rep.rep_name }}
              </td>
            </tr>

            <!-- DATA ROWS -->
            <tr *ngFor="let row of rep.records; let i = index">
              <!-- <td style="border:1px solid black;">{{ i + 1 }}</td> -->
              <!-- <td style="border:1px solid black;">{{ row.booking_date | date:'dd-MM-yyyy' }}</td> -->
              <!-- <td style="border:1px solid black;">{{ row.oder_no }}</td> -->
               <td style="border:1px solid black;">{{ row.book_seller_name }}</td> 
              <td style="border:1px solid black;">{{ row.district }}</td>
              <td style="border:1px solid black;">{{ row.mobile_no }}</td>
              <td style="border:1px solid black;">{{ row.book_name }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.sale_copies }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.return_copies }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.complimentary_copies }}</td>
              <!-- <td style="border:1px solid black;text-align:right;">{{ row.book_price | number:'1.2-2' }}</td> -->
              <!-- <td style="border:1px solid black;text-align:right;">{{ row.sale_price | number:'1.2-2' }}</td> -->
              <td style="border:1px solid black;text-align:right;">{{ row.total  }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.shipping_charges  }}</td>
              <td style="border:1px solid black;text-align:right;">{{  row.totalAmount }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.received_amt  }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.credit_amt  }}</td>
              <td style="border:1px solid black;text-align:right;">{{ row.remaining_amt  }}</td>
              <!-- <td style="border:1px solid black;">{{ row.invoice_no }}</td> -->
              <td style="border:1px solid black;text-align:right;">{{ row.rep_commission_amt  }}</td>
            </tr>

            <!-- ================= REP TOTAL ================= -->
            <tr style="font-weight:bold;">
              <td colspan="4" style="border:1px solid black;text-align:right;">Rep Total</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalSale }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalReturn }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalComp }}</td>
              <!-- <td style="border:1px solid black;text-align:right;">{{ rep.totalBookPrice  }}</td> -->
              <!-- <td style="border:1px solid black;text-align:right;">{{ rep.totalSalePrice  }}</td> -->
              <td style="border:1px solid black;text-align:right;">{{ rep.totalNet  }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalShipping  }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalAmount  }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalReceipt }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalCredit }}</td>
              <td style="border:1px solid black;text-align:right;">{{ rep.totalPending  }}</td>
              <!-- <td style="border:1px solid black;"></td> -->
              <td style="border:1px solid black;text-align:right;">{{ rep.totalCommission  }}</td>
            </tr>

          </ng-container>

          <!-- ================= OFFICE TOTAL ================= -->
          <tr style="font-weight:bold;">
            <td colspan="4" style="border:1px solid black;text-align:right;background-color: #f4b084;">
              Office Rep Total ({{ office.office_rep_name }})
            </td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalSale }}</td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalReturn }}</td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalComp }}</td>
            <!-- <td style="border:1px solid black;text-align:right;">{{ office.totalBookPrice  }}</td> -->
            <!-- <td style="border:1px solid black;text-align:right;">{{ office.totalSalePrice }}</td> -->
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalNet  }}</td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalShipping  }}</td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalAmount  }}</td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalReceipt  }}</td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;"> {{ office.totalCredit  }}</td>
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalPending  }}</td>
            <!-- <td style="border:1px solid black;"></td> -->
            <td style="border:1px solid black;text-align:right;background-color: #f4b084;">{{ office.totalCommission  }}</td>
          </tr>

        </ng-container>

      </tbody>

      <!-- ================= GRAND TOTAL ================= -->
      <tr style="font-weight:bold;background:#c8753f;color:white;">
        <td colspan="4" style="border:1px solid black;text-align:right;">Grand Total</td>
        <td style="border:1px solid black;text-align:right;">{{ grandCopies }}</td>
        <td style="border:1px solid black;text-align:right;">{{ grandRetCopies }}</td>
        <td style="border:1px solid black;text-align:right;">{{ grandCompCopies }}</td>
        <!-- <td style="border:1px solid black;text-align:right;">{{ grandBookPrices  }}</td> -->
        <!-- <td style="border:1px solid black;text-align:right;">{{ grandSalePrices  }}</td> -->
        <td style="border:1px solid black;text-align:right;">{{ grandNet  }}</td>
        <td style="border:1px solid black;text-align:right;">{{ grandShipping  }}</td>
        <td style="border:1px solid black;text-align:right;">{{ grandAmount  }}</td> 
        <td style="border:1px solid black;text-align:right;">{{ grandJama  }}</td>
        <td style="border:1px solid black;text-align:right;"> {{ grandCredit  }} </td>
        <td style="border:1px solid black;text-align:right;">{{ grandYene  }}</td>
        <!-- <td style="border:1px solid black;"></td> -->
        <td style="border:1px solid black;text-align:right;">{{ grandCommission  }}</td>
      </tr>

    </table>
  </div>

  <!-- ================= ACTION BUTTONS ================= -->
  <div class="noPrint d-flex justify-content-end gap-3 px-4 my-3">
    <button class="btn btn-success" (click)="exportExcel('OfficeRepWise')">Export</button>
    <button class="btn btn-primary" (click)=" printPage4()">Print</button>
    <button class="btn btn-secondary" mat-dialog-close>Close</button>
  </div>
</div>

